import { useQuery } from 'react-query';
// 기본 요청 타임아웃 — 서버가 응답을 물고 있으면(70-80명 러시 실측) await 가 영구
// pending 이 되어 입장 로딩이 무한히 남는다. 제출/저장 등 유실되면 안 되는 쓰기 요청은
// 호출부에서 timeoutMs=0(무제한) 또는 더 긴 값을 지정한다.
const FETCH_DEFAULT_TIMEOUT_MS = 15000;
//  API 호출 함수 정의
export const fetchData = async (url, options, noAlert, timeoutMs = FETCH_DEFAULT_TIMEOUT_MS) => {
    // keepalive(언로드 중) 요청은 abort 타이머가 의미 없으므로 그대로 둔다
    const controller = timeoutMs > 0 && !options?.keepalive ? new AbortController() : null;
    const timer = controller ? setTimeout(() => controller.abort(), timeoutMs) : null;
    try {
        const response = await fetch(url, controller ? { ...options, signal: controller.signal } : options);
        if (!response.ok) {
            const result = await response.json();
            throw new Error(result?.message?.format);
        }
        return response.json();
    }
    catch (e) {
        console.log(e);
        // AbortError 는 영문 기본 메시지라 사용자 안내 문구로 치환
        if (e?.name === 'AbortError') {
            e = new Error('요청 시간이 초과되었습니다. 네트워크 확인 후 다시 시도해주세요.');
        }
        if (!noAlert) {
            // 에러 메시지 표시
            APP.UI.alertMessage(e.message);
        }
        throw e;
    }
    finally {
        if (timer)
            clearTimeout(timer);
    }
};
// object convert string
export function objectToQueryString(obj) {
    if (obj === undefined || obj === null) {
        return '';
    }
    return Object.keys(obj)
        .map(key => {
        const value = obj[key];
        if (value === undefined)
            return;
        if (Array.isArray(value)) {
            return value.map(v => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`).join('&');
        }
        else {
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        }
    })
        .join('&');
}
export const useCustomQuery = (key, getData) => {
    return useQuery(key, getData, {
        keepPreviousData: true,
        select: (data) => data.result,
        enabled: false,
        cacheTime: 300000,
        staleTime: 60000,
        refetchInterval: 5000,
        refetchOnWindowFocus: false,
        retry: 3,
        suspense: true, // Suspense 사용 여부
    });
};
export const checkSumbitData = (changeSurveyData, isPreview) => {
    const missingQuestionNumbers = [];
    for (const survey of changeSurveyData) {
        let isAnswered = true;
        if (survey.type === 'choice' || survey.type === 'checkbox') {
            const selectedOptions = survey.data.filter(option => option.checked);
            if (selectedOptions.length === 0 && !isPreview) {
                isAnswered = false;
            }
        }
        else {
            if (survey.data && survey.data.length > 0 && !isPreview) {
                if (!survey.data[0] || survey.data[0].trim() === '') {
                    isAnswered = false;
                }
            }
            else if (survey.data && survey.data.length === 0 && !isPreview) {
                isAnswered = false;
            }
        }
        if (!isAnswered && survey.number !== undefined) {
            missingQuestionNumbers.push(survey.number);
        }
    }
    if (missingQuestionNumbers.length > 0) {
        const missingQuestionsString = missingQuestionNumbers.join(', ');
        throw Error(`${missingQuestionsString}번 항목에 답변하지 않았습니다.`);
    }
};
export const checkSurveyString = (data) => {
    return data.map(({ question_id, values }) => ({
        question_id,
        values: Array.isArray(values) ? values : [values],
    }));
};
export const splitAnswers = (data) => {
    try {
        return data.map(item => ({
            question_id: item.question_id,
            values: Array.isArray(item.values) ? item.values : [item.values]
        }));
    }
    catch {
        return [];
    }
};
